// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610062155/js/" + chunkId + "." + {"44":"37096a9e","225":"99c52c7d","481":"4320d019","486":"56d4f2f5","770":"4c6dd2c3"}[chunkId] + ".0.41136507023240987.chunk.js";
};